import { Grid } from "@material-ui/core";
import { UserField, UserInputTypeKey } from "common/components/input/fields";
import { SubformProps } from "common/components/SubformProps";
import { UpdateUserManageable } from "common/store/user/types";
import React from "react";

export const UserProofSubform = (props: SubformProps<UpdateUserManageable>) =>
  <Grid container spacing={5} direction="column">
    <Grid container item direction="row" spacing={5}>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserField id={"address" as UserInputTypeKey} {...props} />
      </Grid>

      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserField id={"addressZipcode" as UserInputTypeKey} {...props} />
      </Grid>
    </Grid>

    <Grid container item direction="row" spacing={5}>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserField id={"addressCity" as UserInputTypeKey} {...props} />
      </Grid>

      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserField
          id={"addressCountry" as UserInputTypeKey}
          className="autocomplete"
          {...props}
        />
      </Grid>
    </Grid>

    <Grid container item direction="row" spacing={5}>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserField id={"idDocumentType" as UserInputTypeKey} {...props} />
      </Grid>

      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserField id={"idDocumentNumber" as UserInputTypeKey} {...props} />
      </Grid>
    </Grid>

    <Grid container item direction="row" spacing={5}>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserField id={"idDocumentIssueDate" as UserInputTypeKey} {...props} />
      </Grid>

      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserField id={"idDocumentExpiryDate" as UserInputTypeKey} {...props} />
      </Grid>
    </Grid>

    <Grid container item direction="row" spacing={5}>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserField
          id={"idDocumentCountry" as UserInputTypeKey}
          className="autocomplete"
          {...props}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <UserField id={"idDocumentIssuingAgency" as UserInputTypeKey} {...props} />
      </Grid>
    </Grid>
  </Grid>
;
